
    const original = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\"><g style=\"fill:none;fill-rule:evenodd;stroke:#855cd6;stroke-width:1;stroke-linecap:round;stroke-linejoin:round\"><path d=\"M4 4h2v12H4h0a1 1 0 0 1-1-1V5h0a1 1 0 0 1 1-1Z\"/><path fill=\"#855cd6\" d=\"M6 4h10a1 1 0 0 1 1 1v4.25H6Z\"/><path d=\"M6 9h11v6h0a1 1 0 0 1-1 1H6Z\"/></g></svg>";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
